<template>
	<div>
		<header-page
			class="pr-5"
			name="accounting-periods"
			:show-excel="false"
			:title="title"
		/>
		<backButtonRoute/>
		<record-filter
			:clean-filters="cleanFilters"
			:modules="modules"
			@filter="onFilter"
			@clean="onClean"
			@search-record="loadRowRecord"
		/>
		<record-list
			:clean-search="cleanFilters"
			:columns="columns"
			:current-page="currentPage"
			:last-page="table.lastPage"
			:period-id="periodId"
			:period-name="$route.query.periodName"
			:rows="rowsRecord"
			:subsidiary-id="subsidiaryId"
			:subsidiary-name="subsidiaryName"
			@on-page="onPage"
			@on-search="onSearchEvent"
		/>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				hidden
				success-text="Atrás"
				@accept-button-clicked="goToPeriod"
			/>
		</section>
	</div>
</template>

<script>
	import recordFilter from '@/components/records/record-filter';
	import recordList from '@/components/records/record-list';
	import lib from '@/shared/lib';
	import backButtonRoute from '@/components/shared/back-button-route';
	import { format, subDays } from 'date-fns';

	const { getDeeper } = lib;

	function created() {
		this.loadModules();
		this.params.startDate = format(subDays(this.$today, 7), 'YYYY-MM-DD');
		this.params.endDate = this.$today;
	}

	async function loadModules() {
		const params = { subsidiaryId: this.subsidiaryId };
		({ data: this.modulesFilter } = await this.$http.get('type-register', { params }));
		this.modules = this.modulesFilter;
	}

	function onClean() {
		this.currentPage = 1;
		this.params.moduleId = null;
		this.params.startDate = null;
		this.params.endDate = null;
		this.params.page = 1;
		this.params.search = null;
		this.params.status = null;
		this.cleanFilters = true;
		// this.loadData(`register-list/${this.subsidiaryId}/subsidiary`);
	}

	function onFilter({ modelName, value }) {
		if (modelName === 'startDate' || modelName === 'endDate') {
			this.params[modelName] = format(value.value, 'YYYY-MM-DD');
		} else {
			this.params[modelName] = value;
		}
		if (modelName === 'moduleId') {
			const index = this.modules.findIndex(m => m.code === value);
			if (index > -1) {
				this.valuesShow = this.modules[index].templateJson || {};
			}
		}
	}

	function onPage(page) {
		this.currentPage = page;
		this.params.page = page;
		this.loadRowRecord();
	}

	function onSearchEvent(search) {
		this.params.search = search ? search.trim() : null;
		this.loadRowRecord();
	}

	function title() {
		const { periodName } = this.$route.query;
		return this.subsidiaryId ?
			`${this.subsidiaryName} / ${periodName} / ${this.$route.meta.title}` :
			this.$route.meta.title;
	}

	async function loadRowRecord() {
		if (this.params.moduleId === 'VENTA') {
			this.params.moduleId = 1;
		}
		if (this.params.moduleId === 'COMPRA') {
			this.params.moduleId = 2;
		}
		if (this.params.moduleId === 'CTAXPAG') {
			this.params.moduleId = 3;
		}
		if (this.params.moduleId === 'CTAXCOB') {
			this.params.moduleId = 4;
		}
		if (this.params.moduleId === 'INGRESOS') {
			this.params.moduleId = 6;
		}
		if (this.params.moduleId === 'EGRESOS') {
			this.params.moduleId = 7;
		}
		if (this.params.moduleId === 'CAJA') {
			this.params.moduleId = 8;
		}
		if (this.params.moduleId === 'BANCO') {
			this.params.moduleId = 9;
		}
		const params = {
			search: this.params.search,
			subsidiaryId: this.subsidiaryId,
			accountingSeat: this.params.status,
			endDate: this.params.endDate,
			startDate: this.params.startDate,
			page: this.currentPage,
			limit: 10,
		};
		try {
			const response = await this.$http.get(`registers/accounting-seat/${this.params.moduleId}?&sortField=created_at`, { params });
			this.rowsRecord = response.data.map((row) => {
				const newRow = { ...row };
				newRow.isSelected = false;
				const flag = Object.keys(this.valuesShow).length;
				const searchDate = flag ? this.valuesShow.date.split('.') : null;
				const searchEntity = flag ? this.valuesShow.entity.split('.') : null;
				const searchReference = flag ? this.valuesShow.reference.split('.') : null;
				const searchAmount = flag ? this.valuesShow.amount.split('.') : null;
				newRow.dateToShow = searchDate ? getDeeper(...searchDate)(row) : null;
				newRow.entityToShow = searchEntity ? getDeeper(...searchEntity)(row) : null;
				newRow.referenceToShow = searchReference ? getDeeper(...searchReference)(row) : null;
				newRow.amountToShow = searchAmount ? getDeeper(...searchAmount)(row) : null;
				return newRow;
			});
			this.table.lastPage = Number(response.headers['x-last-page']);
		} catch (error) {
			this.showGenericError();
		}
	}

	function goToPeriod() {
		this.goTo('accounting-periods');
	}

	function data() {
		return {
			cleanFilters: false,
			columns: [
				{
					id: 1,
					name: 'Cod',
					tooltip: 'Código de Asiento',
					value: 'codeAccount',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 2,
					name: 'Beneficiario',
					value: 'dateRegister',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 3,
					name: 'F. Creación',
					tooltip: 'Fecha de Creación',
					value: 'data.createdAt',
					checked: true,
					visible: true,
					movil: true,
					largeTitle: true,
				},
				{
					id: 4,
					name: 'Número de Documento',
					value: 'status',
					checked: true,
					visible: true,
				},
				{
					id: 5,
					name: 'Referencia',
					value: 'reference',
					checked: true,
					visible: true,
				},
				{
					id: 6,
					name: 'Monto',
					value: 'amount',
					checked: true,
					visible: true,
					movil: true,
				},
				{
					id: 7,
					name: 'Acciones',
					checked: true,
					visible: true,
					flagVisible: true,
				},
			],
			currentPage: 1,
			modules: [],
			modulesFilter: [],
			rowsRecord: [],
			valuesShow: {},
		};
	}

	export default {
		name: 'page-record',
		components: {
			recordFilter,
			recordList,
			backButtonRoute,
		},
		computed: {
			title,
		},
		created,
		data,
		methods: {
			goToPeriod,
			loadModules,
			onClean,
			onFilter,
			onPage,
			onSearchEvent,
			loadRowRecord,
		},
		props: {
			periodId: [Number, String],
			subsidiaryId: [Number, String],
			subsidiaryName: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/records/page-record.vue